/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {formatIndian} from '../../../utils/formatIndian';

const SupplyChainListData: React.FC<{value: any; item: any}> = ({
  value,
  item
}) => {
  return (
    <div>
      {Array.isArray(value) ? (
        <>
          <div className="formProperty">{item?.label} :</div>
          {value.map((valueItem: any, index: number) => {
            const item1 = item?.format[0].find(
              (formatItem: any) =>
                formatItem.value === valueItem?.[item?.renderFormat[0]]
            );
            const item2 = formatIndian(valueItem?.[item?.renderFormat[1]]);
            const item3 = item?.format[1].find(
              (formatItem: any) =>
                formatItem.value === valueItem?.[item?.renderFormat[2]]
            );
            const item4 = `${formatIndian(
              valueItem?.[item?.renderFormat[3]]
            )} ${item?.unit[0]}`;
            const item5 = `${formatIndian(
              valueItem?.[item.renderFormat[4]]
            )} ${item?.unit[1]}`;

            const finalValue = [
              item1?.label,
              item2,
              item3?.label,
              item4,
              item5
            ];

            const labelValueArray = finalValue.map(
              (eachItem: any, index: number) => {
                return {
                  label: item?.mainLabel[index],
                  value: eachItem
                };
              }
            );

            return (
              <Flex
                key={index}
                vertical
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px'
                }}
              >
                {labelValueArray?.map((item: any, index: number) => {
                  return (
                    <Flex
                      key={index}
                      style={{
                        backgroundColor: '#F3F4F8',
                        padding: '8px 16px'
                      }}
                    >
                      <div className="formProperty" style={{padding: '0px'}}>
                        {item?.label} :
                      </div>
                      <div
                        className="formOutput"
                        style={{padding: '0px 0px 0px 5px'}}
                      >
                        {item?.value}
                      </div>
                    </Flex>
                  );
                })}
              </Flex>
            );
          })}
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default SupplyChainListData;
